// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3dVu6","paramInput":"JobSimulator_paramInput__1Umj2","input":"JobSimulator_input__15LUe"};